import React, { useState, useEffect, useRef } from "react";
import { useSelector, shallowEqual } from "react-redux";
import Portal from "../portal";
import { FiX } from "react-icons/fi";
import {
  API_UpdateSubCategoryById,
  API_CreateSubCategory,
  API_MasterCategoryList,
  API_GetAllCategory,
  url,
} from "../../apis/constant";
import ApiClient from "../../apis/apiClient";
import { toast } from "react-toastify";
import axios from "axios";
import AsyncSelect from "react-select/async";

const EditSubCategory = ({ id, title, getApi }) => {
  const alphanumericRegex = /^[^'"`]+$/;
  const adminToken = localStorage.getItem("wed_admin_token");
  const [error, setError] = useState("");
  const [slugError, setSlugError] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [nameValue, setNameValue] = useState("");
  const [slugValue, setSlugValue] = useState("");
  const [aMasterCatData, setAMasterCategoryData] = useState("");
  const [categryList, setCategoryList] = useState([]);
  const [subCatData, setSubCatData] = useState("");
  const [subCatError, setSubCatError] = useState("");
  const [masterCatError, setMasterCatError] = useState("");
  const [selectedMasterCategoryValue, setSelectedMasterCategoryValue] =
    useState(null);
  const [selectedCategoryValue, setSelectedCategoryValue] = useState(null);
  const [showOnHomepage, setShowOnHomepage] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [existingImage, setExistingImage] = useState("");

  const { palettes } = useSelector(
    (state) => ({
      palettes: state.palettes,
    }),
    shallowEqual
  );
  let { background } = {
    ...palettes,
  };

  const modalRef = useRef(null);
  const [open, setOpen] = useState(false);
  const show = () => {
    getsubcategoryById();
    setOpen(true);
  };
  const hide = () => {
    setOpen(false);
    setNameValue("");
    setSlugValue("");
    setShowOnHomepage(false);
    setSelectedFile(null);
    setExistingImage("");
  };

  const getAllMasterCategory = async (inputValue) => {
    const data = "";
    // setIsApiCall(true);
    const res = await ApiClient.get(
      API_MasterCategoryList +
        `?page=1&sortBy=asc&limit=${30}&searchBy=${inputValue}`,
      data,
      `Bearer ${adminToken}`
    );
    if (res.data.code === 200) {
      // setMasterCategoryData(res.data.data.docs);
      // setIsApiCall(false);
      return res.data.data.docs;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!modalRef || !modalRef.current) return false;
      if (!open || modalRef.current.contains(event.target)) {
        return false;
      }
      setOpen(!open);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, modalRef]);

  const getsubcategoryById = () => {
    axios
      .get(url + API_CreateSubCategory + "/" + id, {
        headers: { Authorization: `Bearer ${adminToken}` },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setNameValue(res.data.data.name);
          setSlugValue(res.data.data.slug);
          setSelectedMasterCategoryValue(res.data.data.masterCategoryId);
          handleAMasterCategory(res.data.data.masterCategoryId);
          setSelectedCategoryValue(res.data.data.categoryId);
          setSubCatData(res.data.data.categoryId.id);
          setShowOnHomepage(res.data.data.showOnHomepage || false);
          setExistingImage(res.data.data.image || "");
        }
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleNameValue = (value) => {
    const limit = 200;
    if (value.length > limit) {
      setError("Please enter less than 200 words.");
    } else if (value && !alphanumericRegex.test(value)) {
      setError("Please enter valid name.");
      setNameValue(value);
      return;
    } else {
      setError("");
      setNameValue(value);
    }
  };

  const handleSlugValue = (value) => {
    setSlugValue(value);
  }

  const handleCategory = () => {
    setIsSubmit(true);
    let isTrue = false;
    if (nameValue === "") {
      setError("Name should not be blank.");
      setIsSubmit(false);
      isTrue = true;
    } else {
      setError("");
    }

    if (slugValue === "") {
      setSlugError("Slug should not be blank.");
      setIsSubmit(false);
      isTrue = true;
    } else {
      setSlugError("");
    }

    if(slugValue.length < 3) {
      setSlugError("Slug length should be greater than 2 characters.");
      setIsSubmit(false);
      isTrue = true;
    } else {
      setSlugError("");
    }

    if (aMasterCatData === "") {
      setMasterCatError("Master Category should not be blank.");
      setIsSubmit(false);
      isTrue = true;
    } else {
      setMasterCatError("");
    }
    if (subCatData === "") {
      setSubCatError("Category should not be blank.");
      setIsSubmit(false);
      isTrue = true;
    } else {
      setSubCatError("");
    }

    if (isTrue) {
      return;
    }

    const formData = new FormData();
    formData.append("name", nameValue);
    formData.append("slug", slugValue);
    formData.append("masterCategoryId", aMasterCatData);
    formData.append("categoryId", subCatData);
    formData.append("showOnHomepage", showOnHomepage);
    if (selectedFile) {
      formData.append("image", selectedFile);
    }

    axios
      .patch(url + API_UpdateSubCategoryById + "/" + id, formData, {
        headers: { Authorization: `Bearer ${adminToken}` },
      })
      .then((res) => {
        if (res.data.code === 200) {
          toast.success(res.data.message);
          hide();
          getApi(10, 1);
        } else if (res.data.code === 400) {
          toast.error(res.data.message);
          setIsSubmit(false);
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err.response.data.message);
      });
  };

  const handleACategory = async (e) => {
    // setSubCatData(e.target.value);
    if(e === null) {
    setSelectedCategoryValue(e);

    }else {

      setSelectedCategoryValue(e);
      setSubCatData(e.id);
    }
  };

  const handleAMasterCategory = async (e) => {
        setCategoryList([]);
        if(e  === null) {
          // localStorage.setItem("masterId", '');setAMasterCategoryData
          setSelectedMasterCategoryValue(null)
          localStorage.setItem("masterId", '');
          getCategoryListUsingMasterId('');
    }else {
      const id = e.id
      setSelectedMasterCategoryValue(e)
      setAMasterCategoryData(id);
      if (id === "") {
        setCategoryList([]);
        // setCategoryData("");
        setSubCatData("");
        return;
      }
      setAMasterCategoryData(id);
      localStorage.setItem("masterId", id);
      getCategoryListUsingMasterId("");
    }
  };

  const getCategoryListUsingMasterId = async (inputValue) => {
    var masterId =  localStorage.getItem("masterId");

    const res = await ApiClient.get(
      API_GetAllCategory +
        `?masterCategoryId=${masterId}&page=1&sortBy=asc&limit=${10}&searchBy=${inputValue}`,
      {},
      `Bearer ${adminToken}`
    );
    if (res.data.code === 200) {
      let full_arr = res.data.data.docs;
      setCategoryList(full_arr);
      return full_arr;
    }
  };

  //
  return (
    <>
      <button
        // className="btn btn-default btn-rounded bg-blue-500 hover:bg-blue-600 text-white "
        style={{ cursor: "pointer", textDecoration: "underline" }}
        type="button"
        onClick={show}
      >
        Edit
      </button>
      {open && (
        <Portal selector="#portal">
          <div className="modal-backdrop fade-in"></div>
          <div
            className={`modal show ${background === "dark" ? "dark-mode" : ""}`}
            data-background={background}
          >
            <div
              className="relative min-w-sm w-auto mx-auto lg:max-w-5xl"
              ref={modalRef}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h3 className="text-xl font-semibold">{title}</h3>
                  <button
                    className="modal-close btn btn-transparent"
                    onClick={hide}
                  >
                    <FiX size={18} className="stroke-current" />
                  </button>
                </div>
                <div className="relative p-4 flex-auto">
                  <label>Title:</label>
                  <div className="inputBoxCategoryCss">
                    <input
                      type="text"
                      placeholder="Please Enter Title"
                      name="name"
                      value={nameValue}
                      onChange={(e) => handleNameValue(e.target.value)}
                      className="inputFields"
                    />
                  </div>
                  {error && (
                    <p style={{ color: "red", padding: "10px 4px" }}>{error}</p>
                  )}
                  <label className="mt-3 block">Slug:</label>
                  <div className="inputBoxCategoryCss">
                    <input
                      type="text"
                      placeholder="Please Enter Slug"
                      name="slug"
                      value={slugValue}
                      onChange={(e) => handleSlugValue(e.target.value)}
                      className="inputFields"
                    />
                  </div>
                  {slugError && (
                    <p style={{ color: "red", padding: "10px 4px" }}>{slugError}</p>
                  )}
                  <label className="mt-3 block">Image:</label>
                  <div className="inputBoxCategoryCss">
                    <input type="file" accept="image/*" onChange={handleFileChange} className="inputFields" />
                  </div>
                  {existingImage && (
                    <div className="mt-2">
                      <img src={`${process.env.REACT_APP_FILE_URL}${existingImage}`} alt="Current" className="h-20 w-20 object-cover" />
                    </div>
                  )}
                  <div className="mt-3 flex items-center gap-2">
                    <input
                      type="checkbox"
                      id="showOnHomepage"
                      checked={showOnHomepage}
                      onChange={(e) => setShowOnHomepage(e.target.checked)}
                      className="form-checkbox h-4 w-4"
                    />
                    <label htmlFor="showOnHomepage" className="text-sm text-gray-700">
                      Show on Homepage
                    </label>
                  </div>
                </div>
                <div className="form-element">
                  <div className="form-label" style={{ marginLeft: "5px" }}>
                    Level 1:
                  </div>
                  <AsyncSelect
                    className="selectWithSearch"
                    cacheOptions
                    defaultOptions
                    // isClearable
                    value={selectedMasterCategoryValue}
                    getOptionLabel={(e) => e.name}
                    getOptionValue={(e) => e.id}
                    loadOptions={getAllMasterCategory}
                    onChange={handleAMasterCategory}
                  />
                  {masterCatError && (
                    <p
                      style={{
                        color: "red",
                        padding: "10px 4px",
                        paddingLeft: "20px",
                      }}
                    >
                      {masterCatError}
                    </p>
                  )}
                </div>

                <div className="form-element">
                  <div className="form-label" style={{ marginLeft: "5px" }}>
                    Level 2:
                  </div>
                  <AsyncSelect
                    className="selectWithSearch"
                    key={categryList.length}
                    cacheOptions
                    defaultOptions
                    // isClearable
                    value={selectedCategoryValue}
                    getOptionLabel={(e) => e.name}
                    getOptionValue={(e) => e.id}
                    loadOptions={ getCategoryListUsingMasterId}
                    onChange={handleACategory}
                  />
                  {subCatError && (
                    <p
                      style={{
                        color: "red",
                        padding: "10px 4px",
                        paddingLeft: "20px",
                      }}
                    >
                      {subCatError}
                    </p>
                  )}
                </div>
                <div className="modal-footer space-x-2">
                  <button
                    className="btn btn-default btn-rounded bg-blue-500 hover:bg-blue-600 text-white"
                    type="button"
                    onClick={hide}
                  >
                    Close
                  </button>
                  {isSubmit ? (
                    <button
                      className="btn btn-default btn-rounded bg-blue-500 hover:bg-blue-600 text-white"
                      type="button"
                      // onClick={() => handleCategory()}
                    >
                      Loading...
                    </button>
                  ) : (
                    <button
                      className="btn btn-default btn-rounded bg-blue-500 hover:bg-blue-600 text-white"
                      type="button"
                      onClick={() => handleCategory()}
                    >
                      Save Changes
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Portal>
      )}
    </>
  );
};

export default EditSubCategory;
